export enum STOCK_STATUS {
  IN_STOCK = 'IN_STOCK',
  OUT_OF_STOCK = 'OUT_OF_STOCK'
}

export enum IMAGE {
  logo = 'logo',
  image1 = 'image1',
  image2 = 'image2',
  image3 = 'image3',
  footer = 'footer',
  header = 'header'
}

export enum CountriesISO3 {
  USA = 'USA',
  AUS = 'AUS',
  TWN = 'TWN'
}

export enum CountriesISO2 {
  DE = 'DE',
  NL = 'NL',
  FR = 'FR',
  IT = 'IT',
  US = 'US'
}

export enum DownloadFileTypes {
  PDF,
  IMAGE,
  ZPL
}

export enum IMAGE_TYPES {
  PNG = 'image/png'
}

export enum StringMaxLengths {
  LETTER = 250,
  A4 = 240,
  FOUR_X_TEN_INCH = 220,
  W298_X_100 = 220,
  FOUR_X_FIVE_INCH = 220,
  W105xH140mm = 220,
}

export enum QrCodeTypes {
  BASE_64,
  URL
}

export enum PAPER_SIZE {
  A4 = 'A4',
  LETTER = 'LETTER',
  FOUR_X_TEN_INCH = 'FOUR_X_TEN_INCH',
  FOUR_X_FIVE_INCH = 'FOUR_X_FIVE_INCH',
  W105xH140mm = 'W105xH140mm',
  W298_X_100 = 'W298_X_100'
}

export enum PDFEntitlementIcon {
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
  COFFEE = 'coffee',
  VIP = 'vip',
  BUYER_CLUB = 'buyer_club',
  CLOSING_DINNER = 'closing_dinner',
  COCKTAIL = 'cocktails',
  EARLY_ACCESS = 'early_access',
  ONSITE_ACCESS = 'onsite_access',
  OPENING_DINNER = 'opening_dinner',
  SIA_MEMBER = 'sia_member',
  CONFERENCE = 'conference_c',
}

export enum BADGE_DOWNLOAD_TYPE {
  EVENT_PORTAL = 'EventPortal',
  ODIN = 'Odin',
  USER_DOWNLOAD = 'UserDownload',
  EXHIBITOR_HUB = 'ExhibitorHub'
}

export enum FONT {
  NOTO_SANS_TMP = 'NOTO_SANS_TMP',
  HELVETICA_BOLD = 'Helvetica-Bold',
  HELVETICA = 'Helvetica',
  JAPANESE = 'JAPANESE',
  JAPANESE_BOLD_800 = 'JAPANESE_BOLD_800',
  CHINESE_SIMPLIFIED = 'CHINESE_SIMPLIFIED',
  NOTO_SANS = 'Noto Sans'
}

export enum JapaneseA4DividerPositions {
  TOP,
  BOTTOM,
  RIGHT,
  LEFT
}

export enum XAppNameEnum {
  EVENT_PORTAL_COMPANY_PROFILE = 'EventPortal.CompanyProfile',
  EVENT_PORTAL_BADGE_MANAGER = 'EventPortal.BadgeManager',
  EXHIBITOR_HUB = 'ExhibitorHub'
}
